export default __webpack_public_path__ + "static/media/nowifi.d8376cb9.png";